/* eslint-disable import/prefer-default-export */

export const isTrustedRedirectUrl = (
  redirectUrl: string,
  currentOrigin: string,
  configuredOrigins: Array<string | undefined>,
) => {
  try {
    const targetUrl = new URL(redirectUrl, currentOrigin);
    const trustedOrigins = [currentOrigin, ...configuredOrigins]
      .filter((origin): origin is string => Boolean(origin))
      .map((origin) => new URL(origin).origin);

    return (
      (targetUrl.protocol === 'https:' || targetUrl.protocol === 'http:') &&
      trustedOrigins.includes(targetUrl.origin)
    );
  } catch (error) {
    return false;
  }
};
